import { render, staticRenderFns } from "./MonthlyPTPTNSubmissionRecordGrid.vue?vue&type=template&id=26116932"
import script from "./MonthlyPTPTNSubmissionRecordGrid.vue?vue&type=script&lang=js"
export * from "./MonthlyPTPTNSubmissionRecordGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports